module.exports = __webpack_public_path__ + "img/IMG_1645_Wood.46c73790.jpg";